import styled from 'styled-components/macro';

export const Wrapper = styled.div<{
  height: string;
}>`
  display: flex;
  flex-direction: row;
  height: ${(props) => props.height}px;
`;
